module.exports = "/img/p4f.svg?483dddaddbb48f40805829e519c901c7";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/identity/p4f.svg
// module id = OCwF
// module chunks = 75